<template>
  <FaIcon :icon="['fas', 'clock']" />
</template>
